import request from './request';

export function stats() {
  return request.get('/admin/dashboard/stats');
}

export function merchantList() {
  return request.get('/admin/merchant/list');
}

export function createMerchant(payload) {
  return request.post('/admin/merchant/create', payload);
}

export function updateSeat(id, seatLimit) {
  return request.post(`/admin/merchant/${id}/seat`, { seat_limit: seatLimit });
}

